module.exports = "<svg viewBox=\"0 0 300 240\"><path d=\"M0 0h300v240H0V0zm478.4-486.2L308.5-316.5 624.8-.2H-784.6V240H624.8L308.5 556.3l169.9 169.9L1084.6 120 478.4-486.2z\" class=\"st0\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/img-box.svg
// module id = 295
// module chunks = 1